// Configuration des liens
export const socialLinks = [
    {
        title: "Instagram",
        description: "Suivez-nous pour voir nos dernières voitures",
        url: "https://instagram.com/sacco_auto_detailing",
        icon: "fab fa-instagram",
        color: "instagram"
    },
    {
        title: "TikTok",
        description: "Découvrez nos vidéos courtes",
        url: "https://tiktok.com/@saccoautodetailing",
        icon: "fab fa-tiktok",
        color: "tiktok"
    },
    {
        title: "Facebook",
        description: "Rejoignez notre communauté Facebook",
        url: "https://www.facebook.com/profile.php?id=61574399271160",
        icon: "fab fa-facebook-f",
        color: "facebook"
    },
    {
        title: "Site Web",
        description: "Visitez notre site officiel",
        url: "https://sacco-auto.fr",
        color: "website",
        logo: "/logo.png"
    }
];

export const profileInfo = {
    name: "Sacco Auto Detailing",
    bio: "Votre partenaire automobile de confiance",
    logo: "/logo.png"
};